export interface UserSubscriptionInfoEntity {
    type: string;
    storeReference: string;
    consecutiveActiveMonths: number;
    startDate?: string;
    endDate?: string;
    subscriptionPrivilege: SubscriptionPrivilegeEntity;
}

export interface SubscriptionPrivilegeEntity {
    vault: boolean;
    progression: boolean;
}

export const subscriptionTypes = {
    freeTrialBasic: 'freeTrialBasic',
    freeTrialPremium: 'freeTrialPremium',
    basic: 'basic',
    premium: 'premium',
    premiumAnywhere: 'premiumAnywhere',
};